export default "__VITE_ASSET__4Qc_o9wG2Gyus0$7tJm$Zg__"